/** Types of nodes in design module flows @see DesignModuleNode._class. */
export enum NodeType {
  banner = 'Banner',
  base = 'BaseNodeModel',
  begin = 'BeginNodeModel',
  condition = 'ConditionNodeModel',
  custom = 'CustomNodeModel',
  data = 'DataNodeModel',
  dataAccessCompletion = 'DataAccessCompletionNodeModel',
  dtmf = 'DtmfNodeModel',
  exit = 'ExitNodeModel',
  input = 'InputNodeModel',
  loopEscalation = 'LoopEscalationNodeModel',
  module = 'ModuleNodeModel',
  moduleReference = 'ModuleReferenceNodeModel',
  note = 'NoteNodeModel',
  playSavedPrompt = 'PlaySavedPromptNodeModel',
  prompt = 'PromptNodeModel',
  promptReference = 'PromptReferenceNodeModel',
  report = 'ReportNodeModel',
  richText = 'RichTextNodeModel',
  savePrompt = 'SavePromptNodeModel',
  session = 'SessionNodeModel',
  sessionCompletion = 'SessionCompletionNodeModel',
  tab = 'TabNodeModel',
  vxmlRender = 'VXMLRenderNodeModel',
  withFiller = 'WithFillerNodeModel'
}
